import { OnboardingAuditField, OnboardingAuditFieldIdentifier } from '@mews-commander/data-access';

export const isAuditUnpaidInvoiceOverview = (audit: OnboardingAuditField) =>
    audit.fieldIdentifier === OnboardingAuditFieldIdentifier.UnpaidInvoiceOverview;

export const isAuditMewsUniversityCoursesCompleted = (audit: OnboardingAuditField) =>
    audit.fieldIdentifier === OnboardingAuditFieldIdentifier.MewsUniversityCoursesCompleted;
